import { render, staticRenderFns } from "./ProtocoloEntregaGuia.vue?vue&type=template&id=47284550&"
import script from "./ProtocoloEntregaGuia.vue?vue&type=script&lang=js&"
export * from "./ProtocoloEntregaGuia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports